// Fix EU (2026-10-01): instalar la plataforma como app y aviso de "sin conexión".
import { useState } from "react";
import { Download, Share, PlusSquare, WifiOff, X } from "lucide-react";
import { usePWA, useEnLinea } from "../pwa";

const CLAVE_AVISO = "cen_aviso_instalar_cerrado";

function InstruccionesIOS({ onClose }) {
  return (
    <div className="fixed inset-0 z-[10001] flex items-center justify-center p-4 bg-black/50" onClick={onClose} data-testid="instalar-ios-modal">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm p-5 space-y-3" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between">
          <h3 className="text-base font-bold text-gray-900">Instalar en iPhone o iPad</h3>
          <button type="button" onClick={onClose} className="p-1.5 rounded-lg text-gray-400 hover:bg-gray-100" aria-label="Cerrar"><X size={16} /></button>
        </div>
        <ol className="space-y-2 text-sm text-gray-700">
          <li className="flex items-start gap-2"><span className="font-bold text-[#2E6DA4]">1.</span><span>Abrí la plataforma en <b>Safari</b>.</span></li>
          <li className="flex items-start gap-2"><span className="font-bold text-[#2E6DA4]">2.</span><span>Tocá <b>Compartir</b> <Share size={14} className="inline -mt-0.5" /> (abajo o arriba de la pantalla).</span></li>
          <li className="flex items-start gap-2"><span className="font-bold text-[#2E6DA4]">3.</span><span>Elegí <b>Agregar a inicio</b> <PlusSquare size={14} className="inline -mt-0.5" /> y confirmá con <b>Agregar</b>.</span></li>
        </ol>
        <p className="text-xs text-gray-500">Queda el ícono de CEN en la pantalla de inicio y se abre como una app.</p>
      </div>
    </div>
  );
}

// Opción del menú lateral: aparece solo cuando el navegador permite instalar.
export function InstalarAppItem({ onClose }) {
  const { puedeInstalar, iosSinInstalar, instalar } = usePWA();
  const [verIOS, setVerIOS] = useState(false);
  if (!puedeInstalar && !iosSinInstalar) return null;
  return (
    <>
      <button
        type="button"
        onClick={() => (puedeInstalar ? instalar().then(() => onClose?.()) : setVerIOS(true))}
        className="w-full flex items-center gap-2.5 px-3 py-2 rounded-xl text-[12.5px] font-medium text-[#8fb8de] hover:text-white hover:bg-white/[0.06] transition-all duration-150"
        data-testid="nav-instalar-app"
      >
        <Download size={14} strokeWidth={1.5} />
        <span>Instalar app</span>
      </button>
      {verIOS && <InstruccionesIOS onClose={() => setVerIOS(false)} />}
    </>
  );
}

// Aviso en el celular para instalar la app (se puede cerrar y no vuelve a aparecer).
export function AvisoInstalarApp() {
  const { puedeInstalar, iosSinInstalar, instalar } = usePWA();
  const [cerrado, setCerrado] = useState(() => {
    try { return localStorage.getItem(CLAVE_AVISO) === "1"; } catch (_e) { return false; }
  });
  const [verIOS, setVerIOS] = useState(false);
  if (cerrado || (!puedeInstalar && !iosSinInstalar)) return null;
  const cerrar = () => {
    try { localStorage.setItem(CLAVE_AVISO, "1"); } catch (_e) { /* sin almacenamiento */ }
    setCerrado(true);
  };
  return (
    <div className="lg:hidden flex items-center gap-3 px-4 py-2.5 bg-[#EBF2F9] border-b border-[#D9EAF8]" data-testid="aviso-instalar-app">
      <img src="/icons/icon-192.png" alt="" className="w-8 h-8 rounded-lg border border-white shadow-sm flex-shrink-0" />
      <p className="flex-1 min-w-0 text-xs text-[#1A4B7A] leading-snug">Instalá <b>CEN ERP</b> en el celular y abrila como una app.</p>
      <button
        type="button"
        onClick={() => (puedeInstalar ? instalar().then((ok) => ok && cerrar()) : setVerIOS(true))}
        className="flex-shrink-0 text-xs font-semibold text-white bg-[#2E6DA4] hover:bg-[#245A8A] px-3 py-1.5 rounded-lg"
        data-testid="aviso-instalar-btn"
      >
        Instalar
      </button>
      <button type="button" onClick={cerrar} className="flex-shrink-0 p-1 text-[#2E6DA4]/70 hover:text-[#1A4B7A]" aria-label="Cerrar aviso" data-testid="aviso-instalar-cerrar">
        <X size={15} />
      </button>
      {verIOS && <InstruccionesIOS onClose={() => setVerIOS(false)} />}
    </div>
  );
}

export function BarraSinConexion() {
  const enLinea = useEnLinea();
  if (enLinea) return null;
  return (
    <div className="flex items-center justify-center gap-2 px-4 py-1.5 bg-amber-500 text-white text-xs font-semibold text-center" role="status" data-testid="barra-sin-conexion">
      <WifiOff size={13} className="flex-shrink-0" />
      Sin conexión: lo que cargues no se va a guardar hasta que vuelva la señal.
    </div>
  );
}
